/*
 * object {
 *    subtraction,
 *    textures,
 *    removeBrushByPencil,
 *    sampleToGetMedium,
 *    samplePencilTexture,
 *    splatRadius,
 *    zThreshold,
 *    fluidity,
 *    deltaTime,
 *    color,
 *    splatVelocityScale
 * }
 * */
const calculatePropertiesForBrush = (settings) => {
  const properties = {};

  properties.subtraction = settings.useAsRag || settings.useAsPencil;

  properties.textures = {
    paintTexture: 'splatBrushPaintTexture',
    paintTempTexture: 'splatBrushPaintTempTexture',
    divergenceTexture: 'splatBrushDivergenceTexture',
    pressureTexture: 'splatBrushPressureTexture',
    pressureTempTexture: 'splatBrushPressureTempTexture',
    velocityTexture: 'splatBrushVelocityTexture',
    velocityTempTexture: 'splatBrushVelocityTempTexture',
  };

  properties.removeBrushByPencil = false;
  properties.sampleToGetMedium = false;
  properties.samplePencilTexture = false;

  properties.splatRadius = settings.splatRadius * settings.brushScale;

  properties.zThreshold = settings.brushZThreshold * settings.brushScale;

  properties.fluidity = settings.primary.fluidity;
  properties.deltaTime = 1.0 / settings.primary.deltaTimeDivider;

  if (settings.useAsPencil) {
    properties.splatRadius = Math.min(settings.paintRemovingScale * properties.splatRadius, settings.paintRemovingMaxSize);
    properties.fluidity = settings.secondary.fluidity;
    properties.deltaTime = 1.0 / settings.secondary.deltaTimeDivider;

    properties.removeBrushByPencil = true;
  }

  let medium, height;

  if (properties.subtraction) {
    height = 0.0;
    medium = 1.0;
  } else {
    height = settings.medium;
    medium = 1.0 - settings.medium;
  }

  const minNS = settings.minimalNormalScale;

  const mediumCoeff = Math.pow(height, 0.3);
  const normalScale = settings.normalScale / 100;
  let normals = 1 - (minNS + (255 - minNS) * mediumCoeff) / 255;
  normals = normalScale * normals;

  properties.color = [0.0, normals, medium, undefined];

  properties.splatVelocityScale = settings.splatVelocityScale;
  properties.medium = settings.medium;

  // testing
  properties.alpha = settings.global.alpha;
  properties.useGlobalAlpha = settings.global.useGlobalAlpha;
  properties.force = settings.force;
  properties.getForceFromPen = settings.getForceFromPen;

  return properties;
};

export default calculatePropertiesForBrush;
